import { MapActions, MapState } from '../store/types/map';
import { Model } from '../store/types/page';
import { useStoreActions, useStoreState } from './store';

export const usePageActions: MapActions<Model> = (mapActions) => useStoreActions((actions) => mapActions(actions.page));
export const usePageState: MapState<Model> = (mapState) => useStoreState((state) => mapState(state.page));
